// The dental specialty string.
//
// READ dentist-app/docs/CORE.md §4 BEFORE TOUCHING THIS. There are TWO dental
// strings in the platform and they render identically:
//
//   'دندانپزشکی'   10 codepoints, NO ZWNJ  — SPECIALTIES[18] in the doctor
//                                            client, i.e. what doctor.specialty
//                                            actually holds. THIS ONE.
//   'دندان‌پزشکی'  11 codepoints, WITH U+200C — a CLINIC_TYPES value, forty
//                                            lines away in the same file.
//
// Copying the wrong one produces a value the server-side gate does not accept,
// and it looks perfectly correct in review.
//
// This constant exists to be WRITTEN (onboarding sends it, the profile screen
// shows it locked). It is deliberately NOT a comparison helper: whether a stored
// specialty counts as dental is decided server-side by the normalized predicate
// in parsina.bff.dentist/src/auth/specialty.js, and `me { isDentist }` is how
// this client learns the answer. Never write `=== DENTAL_SPECIALTY` to gate a
// screen — a real row may hold 'متخصص دندانپزشکی'.
//
// i18n-exempt: a stored identifier, not UI copy — and it is rendered verbatim,
// never translated. Both the profile field and the onboarding step show the
// STORED string (falling back to this constant when the profile has none), so
// what the dentist reads is exactly what doctorpreference holds. Translating it
// would show a Persian label for a value the server never received.
export const DENTAL_SPECIALTY = 'دندانپزشکی';
